import { useTranslation } from 'react-i18next';
import type { KpiCardData } from '@/hooks/useHomeData';

interface KpiGridProps {
  items: KpiCardData[];
}

export function KpiGrid({ items }: KpiGridProps) {
  const { t } = useTranslation();
  return (
    <div className="kpi-grid">
      {items.map((k) => (
        <div key={k.id} className="kpi-card" data-tone={k.tone}>
          <div className="kpi-label">{t(k.labelKey)}</div>
          <div className="kpi-value">
            {k.value}
            {k.unit && <small>{k.unit}</small>}
          </div>
          <div className={`kpi-trend ${k.trendDir}`}>
            <span className="material-symbols-outlined">
              {k.trendDir === 'up' ? 'trending_up' : 'trending_down'}
            </span>
            {k.trendText}
          </div>
        </div>
      ))}
    </div>
  );
}
